export const DEALER_TYPE = 'dealer';
export const SESSION_CHAT_STATE_KEY = 'PDP_CHAT_STATE';
